import {
  UpdateReasonCommandInput,
  UpdateReasonCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { reasonKeys } from 'src/data/api/helios-service-ts/reason/queries/keys';
import { reasonService } from 'src/data/api/helios-service-ts/reason/service';

/**
 * React Query mutation hook for updating an existing reason.
 * Invalidates the reasons list on success to trigger a re-fetch.
 */
export const useUpdateReasonMutation = (
  options?: Omit<
    UseMutationOptions<UpdateReasonCommandOutput, Error, UpdateReasonCommandInput>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (data: UpdateReasonCommandInput) => reasonService.update(data),
    async onSuccess(data, variables, onMutateResult, context) {
      await queryClient.invalidateQueries({ queryKey: reasonKeys.all });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
